import cogoToast from "cogo-toast";
function debounce(func, delay) {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
}
class Toaster {
  success = (message) => {
    let options = { position: "top-right", heading: "" };
    message && cogoToast.success(message, options);
  };

  error = debounce((message) => {
    // message = message != undefined ? message : 'Server Error';
    let options = { position: "top-right", heading: "", toastId: "error1" };
    cogoToast.error(message, options);
  }, 1000);

  warn = (message) => {
    let options = { position: "top-right", heading: "" };
    message && cogoToast.warn(message, options);
  };

  info = (message) => {
    let options = { position: "top-right", heading: "" };
    message && cogoToast.info(message, options);
  };
}

export const toasts = new Toaster();
